import React from 'react';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import Image from '@framework/router/Next/Image';
import IconValidatedLabel from '@dealroadshow/uikit-icon/IconValidatedLabel';
import CliffordChanceLogo from '@framework/assets/customers/svg/cliffordChance.svg';
import styles from './validatedBanner.module.scss';

const ValidatedBanner = () => (
  <div className={ styles.bannerBackground }>
    <SectionContainer size="large">
      <div className={ styles.bannerWrapper }>
        <div className={ styles.bannerContent }>
          <IconValidatedLabel />
          <p className={ styles.description }>
            Validated for regulatory compliance by a leading global law firm.
          </p>
        </div>
        <div className={ styles.divider } />
        <div className={ styles.logoWrapper }>
          <Image
            src={ CliffordChanceLogo.src }
            title="Clifford Chance"
            alt="Clifford Chance"
            width={ 134 }
            height={ 15 }
          />
        </div>
      </div>
    </SectionContainer>
  </div>
);

export default ValidatedBanner;
